import React, { useState } from 'react'
import ChecklistIcon from '@mui/icons-material/Checklist';
import BuildIcon from '@mui/icons-material/Build';
import "./TabsComponent.css"
import mockSkillIcon from "../../assets/mock_skill_img.png"
import mockSkillSection from "../../assets/mock_skill_section_img.gif"
import mockSkillResource from "../../assets/mock_skill_resource_img.png"

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return null;
}

function setCookie(cname, cvalue) {
    const d = new Date();
    document.cookie = cname + "=" + cvalue + ";" + ";path=/";
}

function TabsComponent(props) {

    const getDataFromCookie = getCookie("data")
    const dataArr = getDataFromCookie === null ? [4, 7, 3, 5, 4, 3] : [...getDataFromCookie.split(",", 6).map(n => +n)]
    const [selectedSkill, setSelectedSkill] = useState(0)
    const [selectedSkillStep, setSelectedSkillStep] = useState(0)
    const [selectedColor, setSelectedColor] = useState("65, 128, 127")
    const skillsData = [
        {
            name: "ACTIVE LISTENING",
            headLine: 'The receiving, retaining and processing of information or ideas',
            description: `This skill is all about being able to effectively receive information - whether it comes from customers, colleagues or stakeholders.\n\nInitially, the skill steps concentrate on being able to listen effectively to others - including remembering short instructions, understanding why others are communicating and recording important information.\n\nIndividuals then focus on how they demonstrate that they are listening effectively, thinking about body language, open questioning and summarising and rephrasing.\n\nBeyond that, the focus is on being aware of how they might be being influenced by a speaker, through tone and language.\n\nThe final steps are about critical listening - comparing perspectives, identifying biases, evaluating ideas and being objective.`,
            color: '65, 128, 127',
            steps: [
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 1, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            link: "1",
                            url: "https://hbr.org/podcast/2024/01/practice-your-active-listening-skills"
                        },
                        {
                            link: "2",
                            url: "https://podcasts.apple.com/us/podcast/listening-skills/id1528805181"

                        },
                        {
                            link: "3",
                            url: "https://youtu.be/7wUCyjiyXdg?si=NZnq67R8EiB3sIHB"

                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "Barriers to listening",
                            content: "We cannot listen if we do not try to, if anything is in the way of our ears, or if we are thinking about something else.\n\nIt is important to listen because:\n\nWe might learn information that helps to protect us, or to keep us safe\nWe might understand how someone else is feeling about something \nWe might learn how to do something better\nWe might understand something new that we hadn’t understood before"
                        }
                    ]
                },
                {
                    headLine: "I listen to others and can remember short instructions",
                    preRequisite: "To achieve Step 2, individuals will have to demonstrate that they can listen to and recall a short series of 3-5 instructions.\n\nThis builds on the previous step of being able to listen without interrupting and starts to focus on the retention of information. It might apply to listening to a manager, instructor or a peer.",
                    resources: [
                        {
                            link: "http://skillsbuilder.org/homezone",
                        },
                        {
                            link: "https://www.skillsbuilder.org/benchmark",
                        },
                        {
                            link: "https://launchpad.skillsbuilder.org/lesson/speaking-clearly-to-someone-you-know/",
                        },
                    ],
                    sections: [
                        {
                            headLine: "When we have to listen to instructions",
                            content: "We have to listen to instructions in many different parts of our lives: whether we are being taught something new, being given a job to do, or just completing tasks in our wider lives. "
                        },
                        {
                            headLine: "Why recalling instructions matters",
                            content: "We must listen to instructions carefully – to make sure that we do exactly what is being expected, so that we don’t make mistakes or place ourselves into situations of danger."
                        }
                    ]
                },
                {
                    headLine: "I listen to others and can ask questions if I don't understand",
                    preRequisite: "To achieve Step 3, individuals will show that they can listen and then ask questions to clarify their understanding.\n\nThis step builds on the previous two steps of Listening, which focused on being able to listen without interrupting, and then being able to recall basic instructions.",
                    resources: [
                        {
                            link: "http://skillsbuilder.org/homezone",
                        },
                        {
                            link: "https://www.skillsbuilder.org/benchmark",
                        },
                        {
                            link: "https://launchpad.skillsbuilder.org/lesson/speaking-clearly-to-someone-you-know/",
                        },
                    ],
                    sections: [
                        {
                            headLine: "How to check your understanding when listening",
                            content: "Even if you are a good listener, what you understand will only be as good as how clear the communication is that you are receiving.\n\nBefore you can expand your understanding further, it is often helpful to check that you have understood what you have heard. If you don’t then sometimes misunderstandings can grow.\n\nSome ways of checking your understanding are:\n\nRepeating back what you think you heard\nRephrasing what you heard to check that you understand the meaning\nDrawing a link to something comparable to check your understanding – for example, ‘is that like the time that…’ or ‘is this similar to…’"
                        },
                        {
                            headLine: "Using questions to check your understanding",
                            content: "When you ask questions to check your understanding, you should first reflect on what you have already understood so that your questions are relevant\n\nSome ways of thinking through whether you understand something, might be to think through the key questioning words:\n\nWho – who is involved, and how?\nWhat – what is happening?\nWhere – where is this taking place?\nWhen – when is this happening; at what time and for how long?\nHow – how is this going to happen; what are the steps that will be followed? \nTo make sure you are asking good questions, make sure that they are relevant to the situation. Questions that are not relevant will waste time and suggest to the speaker that you have not been listening."
                        }
                    ]
                },
                {
                    headLine: "I listen to others and can tell someone else what it was about",
                    preRequisite: "To achieve Step 4, individuals will need to be able to listen, and retain, recall and share what they have heard.\n\nIn Steps 1 and 2 individuals focused on their ability to listen to others and remember simple instructions, and to use questioning to check their understanding. This step builds off this by dealing with the recalling and retelling of longer pieces of information.",
                    resources: [
                        {
                            link: "http://skillsbuilder.org/homezone",
                        },
                        {
                            link: "https://www.skillsbuilder.org/benchmark",
                        },
                        {
                            link: "https://launchpad.skillsbuilder.org/lesson/speaking-clearly-to-someone-you-know/",
                        },
                    ],
                    sections: [
                        {
                            headLine: "Listen effectively and stay focused",
                            content: "In the previous steps, some approaches to ensuring focus were discussed, along with the importance of being in the right frame of mind.\n\nOne simple model that was introduced in Step 1 to do this is to:\n\nStop anything that might be a distraction. That might include putting down stationery or tools, not writing or reading anything else, and ensuring that there are no distracting background noises. \nFocus on the speaker, by looking at them and being ready to receive the instructions. Your brain must be in a place of actively trying to remember what is being said. You cannot be thinking about other things. ‍\nRepeat what you are hearing in your head several times so that you have been able to process them and check that you understand what they mean in your head."
                        },
                        {
                            headLine: "Retaining and processing information",
                            content: "Most people find it difficult to recall anything verbatim (that is, exactly in the same way that they were told it). Recalling what is being heard is not like trying to record in real-time what is being said. \n\nInstead, people remember extended things they hear in one of several ways:\n\nThey relate a new piece of knowledge to what they already know and fit it into an existing conceptual framework. For example, they might link something geographically, or place it in a historical context. Or they might link a concept in science to something that they have observed themselves.\nAlternatively, people turn the information into a sequence or story that they can follow – humans are good at using stories as a way of storing information. \nFinally, thinking about the implications and feelings about what is being heard can be a very effective way of processing information. \nIn any case, it often takes a little time to think and to process what has been heard before we can share that information on with someone else. Taking a bit of thinking time is a good idea."
                        }
                    ]
                },
                {
                    headLine: "I listen to others and can tell why they are communicating with me",
                    preRequisite: "To achieve step 5, individuals will need to understand the main reasons why others may want to communicate with them and to be able to identify when each is being used.\n\nIn the steps so far, the focus has been on the tools of effective listening, but to make progress individuals need to be able to start identifying what the purpose is behind what they are hearing.",
                    resources: [
                        {
                            link: "http://skillsbuilder.org/homezone",
                        },
                        {
                            link: "https://www.skillsbuilder.org/benchmark",
                        },
                        {
                            link: "https://launchpad.skillsbuilder.org/lesson/speaking-clearly-to-someone-you-know/",
                        },
                    ],
                    sections: [
                        {
                            headLine: "Why people communicate",
                            content: "Some of the main reasons why people communicate are:\n\nTo share information\nTo share an opinion or view\nTo express their feelings \nTo request something that they need\nTo learn about others \nTo build relationships\nTo give instructions\nTo encourage others\nSometimes communication might combine two or more of these purposes – for example:\n\nTo give instructions and encourage someone to follow them \nOr to share information and then their opinion on that information"
                        },
                        {
                            headLine: "Why it matters why someone is communicating with you",
                            content: "Understanding the purpose behind someone’s communication with us helps us to be as prepared as possible for processing what is going on and responding appropriately.\n\nIf we misunderstand the purpose of the communication we might be unprepared to take any necessary actions after listening to the other individual. For example, if we think someone is presenting information we might not be prepared to process instructions. Or if we think someone is trying to be encouraging, we might be unhappy when they express a different opinion to us. \n\nCommunication always works better, and is easier to listen and respond to, when we are clear on what the purpose of the communication is."
                        }
                    ]
                },
                {
                    headLine: "I speak effectively by using appropriate language",
                    preRequisite: "To achieve Step 6, individuals will understand that they need to consider the language that they are using when speaking and choose appropriate language to the setting.\n\nPreviously, in Steps 3 and 4, the focus was on speaking effectively by making points in a logical order and thinking about what listeners already knew. This Step builds on this, but focuses on the way that someone is speaking. This theme continues in Step 6, which introduces tone, expression and gesture too.",
                    resources: [
                        {
                            link: "http://skillsbuilder.org/homezone",
                        },
                        {
                            link: "https://www.skillsbuilder.org/benchmark",
                        },
                        {
                            link: "https://launchpad.skillsbuilder.org/lesson/speaking-clearly-to-someone-you-know/",
                        },
                    ],
                    sections: [
                        {
                            headLine: "Language and how it varies",
                            content: "There are lots of ways to communicate the same meaning. The words that we choose to say to communicate something give the language that we are using.\n\nThere are three broad types of language that we can consider:\n\nInformal: This is relaxed language, where we might be speaking to friends outside of work or in a social situation. We might use slang or speak in a jokey way. We can use this because there is a shared understanding of what we mean that might be particular to those relationships. \nFormal: This is ‘speaking properly’. We would avoid using slang or speaking in a jokey way. Instead, we use full sentences, using conjunctions, and more sophisticated vocabulary. This way of speaking can be understood much more widely, and so we can use it in lots of different settings.‍\nTechnical: This is advanced language that we might use when working closely with someone where we have shared expertise. For example, two plumbers or lawyers or teachers might be able to use language, abbreviations or acronyms with each other that would not make any sense in the wider world. This way of speaking works well for people who share that technical understanding, but it is impossible to understand if you don’t."
                        },
                        {
                            headLine: "Choosing the right language for the setting",
                            content: "It is crucial to select the right language for the setting so that those people who are listening to you have the best chance of understanding what you are telling them.\n\nIt would feel strange to use formal language with your friends, although they would comprehend you. They might not follow you if you start using unfamiliar technical language.\nSimilarly, many people would feel uncomfortable being spoken to informally by someone who they did not know well. They might be confused about what their relationship is with you, or think that you were unrespectful towards them.\nFinally, anyone who does not have the same sort of technical expertise as you would find it very hard to follow technical language, and might feel that they were looking foolish if they couldn’t understand what you were saying. \nIn summary:\n\nInformal language: For friends and people you know well\nFormal language: For most people and settings, and people you don’t know\nTechnical language: For speaking to others with shared technical expertise"
                        }
                    ]
                },
                {
                    headLine: "I speak effectively by using appropriate tone, expression and gesture",
                    preRequisite: "To achieve Step 8, individuals will have to show that they can use the appropriate tone, expression and gesture in different settings.\n\nIn the previous step, the focus was on how to speak effectively by using appropriate language – that is, the right words. This step is about the other elements that give meaning to what is said – the tone, expression and gesture.",
                    resources: [
                        {
                            link: "http://skillsbuilder.org/homezone",
                        },
                        {
                            link: "https://www.skillsbuilder.org/benchmark",
                        },
                        {
                            link: "https://launchpad.skillsbuilder.org/lesson/speaking-clearly-to-someone-you-know/",
                        },
                    ],
                    sections: [
                        {
                            headLine: "What is tone?",
                            content: "Simply put, tone is how we say the words that we are speaking. \n\nWe can explore this with a simple example – “you could do that better.” Without changing the words, the way that sounds and the meaning it conveys can vary a lot depending on how someone says those words. \nThat simple sentence could sound positive – that you can do that better than someone else\nOr it could sound exasperated – that you should have done something better, or that you doing it is a low expectation, and someone else should have done better \nIt might sound like a question – an invitation to answer whether you think you could do it better?  \nOr it might seem like a direct instruction – that the expectation is that you could, and now will do something better"
                        },
                        {
                            headLine: "How does tone vary?",
                            content: "It is incredible how much meaning comes from the way that something is said, rather than the words themselves. \n\nWe can refer to this way that something is said as the tone of speaking. This tone varies by several dimensions:\n\nPitch: This about how high or low someone is speaking \nTempo: How quickly someone is speaking \nVolume: This is how loudly or quietly someone is speaking‍\nIntonation: This is about where the emphasis is placed on different words"
                        }
                    ]
                },
                {
                    headLine: "I speak engagingly by using facts and examples to support my points",
                    preRequisite: "To achieve Step 9, individuals will be able to use visual aids to support the points they are making when they are speaking. \n\nThe focus in the last step was how to talk engagingly by using facts and examples to support the points that have been made. This step extends that by looking at how visual aids like props, drawings or written slides can help to make speaking more engaging.",
                    resources: [
                        {
                            link: "http://skillsbuilder.org/homezone",
                        },
                        {
                            link: "https://www.skillsbuilder.org/benchmark",
                        },
                        {
                            link: "https://launchpad.skillsbuilder.org/lesson/speaking-clearly-to-someone-you-know/",
                        },
                    ],
                    sections: [
                        {
                            headLine: "What are visual aids?",
                            content: "A visual aid is something that helps to illustrate or show what is being said.\n\nExamples of visual aids include:\n\nImages or photographs \nWritten text, particularly a summary of key points (for example, bullet points) \nFilms or animations\nProps or models"
                        },
                        {
                            headLine: "The benefits of using visual aids",
                            content: "Visual aids can be particularly helpful in sharing new ideas or concepts with listeners, or if you are trying to help people imagine something that they have not seen before. It can be difficult only to describe things in words, and sometimes it is necessary also to see something for it to make sense. \nIf you are speaking for a longer time, having visual aids will help people to follow and understand your talk. That is because what people remember is a combination of what they hear but also what they see or read. \nIt can be tough as a listener just to concentrate on the words that someone is saying for an extended period. The use of visual aids can help to break up that period of just listening. \nIf you are sharing statistics or facts to support what you are speaking about (as explored in the previous step) then sometimes a visual graph or some of the critical statistics written down can help listeners to understand that information better. \nFinally, visual aids can help to provide a context to what you are saying. For example, a short film clip of a particular country or event can help bring it to life for the listeners, who will then be ready to hear what you have to say about it. "
                        }
                    ]
                },
                {
                    headLine: "I speak engagingly by using tone, expression and gesture to engage listeners",
                    preRequisite: "To achieve Step 9, individuals will show that they can use their tone, expression and gesture to engage listeners with what they are saying. \n\nIn Step 6, the concepts of tone, expression and gesture were introduced. This step goes much further than that by focusing on how to use tone, expression and gesture to speak engagingly.",
                    resources: [
                        {
                            link: "http://skillsbuilder.org/homezone",
                        },
                        {
                            link: "https://www.skillsbuilder.org/benchmark",
                        },
                        {
                            link: "https://launchpad.skillsbuilder.org/lesson/speaking-clearly-to-someone-you-know/",
                        },
                    ],
                    sections: [
                        {
                            headLine: "Why are they important?",
                            content: "When we are listening, we are building up an understanding of what is being communicated. This understanding is not just from the words themselves, but also how they are being said and the way someone is moving their body and their face. When we listen, we take clues from each of these to build up our understanding of what someone is communicating."
                        },
                        {
                            headLine: "Choosing the right tone",
                            content: "Pitch: Try to keep your pitch from low to medium. Low pitch gives the appearance of calm and confidence, whereas a high pitch gives the opposite impression. However, some changing of your pitch through your talk can help to provide variety that makes listening more interesting. \nTempo: Try to speak at a moderate pace. Speaking slowly gives the impression of calm and control, whereas speaking too quickly makes someone seem panicked and not in control – and can also be hard to follow. It can work well to speak at a moderate pace so that the audience does not get bored, but to include pauses so that they can think about what you have said. \nVolume: Speak at a volume that makes it easy for the listener to hear you, but not too loud that they are uncomfortable. You can change your volume over time – for example, if you want someone to pay close attention or lean in, you can slightly lower your volume. Sometimes speakers, particularly with larger audiences, speak more loudly at other times to show passion and emphasis on what they are saying. \nIntonation: Generally, a downward intonation adds gravitas and authority to what is being said – it sounds like a statement rather than an invitation for discussion or disagreement."
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 10, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            link: "http://skillsbuilder.org/homezone",
                        },
                        {
                            link: "https://www.skillsbuilder.org/benchmark",
                        },
                        {
                            link: "https://launchpad.skillsbuilder.org/lesson/speaking-clearly-to-someone-you-know/",
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
            ]
        },
        {
            name: "WRITTEN COMMUNICATION",
            headLine: 'The receiving, retaining and processing of information or ideas',
            description: `This skill is all about being able to effectively receive information - whether it comes from customers, colleagues or stakeholders.\n\nInitially, the skill steps concentrate on being able to listen effectively to others - including remembering short instructions, understanding why others are communicating and recording important information.\n\nIndividuals then focus on how they demonstrate that they are listening effectively, thinking about body language, open questioning and summarising and rephrasing.\n\nBeyond that, the focus is on being aware of how they might be being influenced by a speaker, through tone and language.\n\nThe final steps are about critical listening - comparing perspectives, identifying biases, evaluating ideas and being objective.`,
            totalSteps: 10,
            completedSteps: dataArr[0],
            color: '127, 181, 52',
            steps: [
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            link: "http://skillsbuilder.org/homezone",
                        },
                        {
                            link: "https://www.skillsbuilder.org/benchmark",
                        },
                        {
                            link: "https://launchpad.skillsbuilder.org/lesson/speaking-clearly-to-someone-you-know/",
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
            ]
        },
        {
            name: "SPEAKING",
            headLine: 'The receiving, retaining and processing of information or ideas',
            description: `This skill is all about being able to effectively receive information - whether it comes from customers, colleagues or stakeholders.\n\nInitially, the skill steps concentrate on being able to listen effectively to others - including remembering short instructions, understanding why others are communicating and recording important information.\n\nIndividuals then focus on how they demonstrate that they are listening effectively, thinking about body language, open questioning and summarising and rephrasing.\n\nBeyond that, the focus is on being aware of how they might be being influenced by a speaker, through tone and language.\n\nThe final steps are about critical listening - comparing perspectives, identifying biases, evaluating ideas and being objective.`,
            totalSteps: 10,
            completedSteps: dataArr[0],
            color: '65, 128, 127',
            steps: [
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            link: "http://skillsbuilder.org/homezone",
                        },
                        {
                            link: "https://www.skillsbuilder.org/benchmark",
                        },
                        {
                            link: "https://launchpad.skillsbuilder.org/lesson/speaking-clearly-to-someone-you-know/",
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
            ]
        },
        {
            name: "PROBLEM SOLVING",
            headLine: 'The receiving, retaining and processing of information or ideas',
            description: `This skill is all about being able to effectively receive information - whether it comes from customers, colleagues or stakeholders.\n\nInitially, the skill steps concentrate on being able to listen effectively to others - including remembering short instructions, understanding why others are communicating and recording important information.\n\nIndividuals then focus on how they demonstrate that they are listening effectively, thinking about body language, open questioning and summarising and rephrasing.\n\nBeyond that, the focus is on being aware of how they might be being influenced by a speaker, through tone and language.\n\nThe final steps are about critical listening - comparing perspectives, identifying biases, evaluating ideas and being objective.`,
            totalSteps: 10,
            completedSteps: dataArr[0],
            color: '127, 181, 52',
            steps: [
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            link: "http://skillsbuilder.org/homezone",
                        },
                        {
                            link: "https://www.skillsbuilder.org/benchmark",
                        },
                        {
                            link: "https://launchpad.skillsbuilder.org/lesson/speaking-clearly-to-someone-you-know/",
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
            ]
        },
        {
            name: "CREATIVE THINKING",
            headLine: 'The receiving, retaining and processing of information or ideas',
            description: `This skill is all about being able to effectively receive information - whether it comes from customers, colleagues or stakeholders.\n\nInitially, the skill steps concentrate on being able to listen effectively to others - including remembering short instructions, understanding why others are communicating and recording important information.\n\nIndividuals then focus on how they demonstrate that they are listening effectively, thinking about body language, open questioning and summarising and rephrasing.\n\nBeyond that, the focus is on being aware of how they might be being influenced by a speaker, through tone and language.\n\nThe final steps are about critical listening - comparing perspectives, identifying biases, evaluating ideas and being objective.`,
            totalSteps: 10,
            completedSteps: dataArr[0],
            color: '65, 128, 127',
            steps: [
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            link: "http://skillsbuilder.org/homezone",
                        },
                        {
                            link: "https://www.skillsbuilder.org/benchmark",
                        },
                        {
                            link: "https://launchpad.skillsbuilder.org/lesson/speaking-clearly-to-someone-you-know/",
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
            ]
        },
        {
            name: "MINDFULNESS",
            headLine: 'The receiving, retaining and processing of information or ideas',
            description: `This skill is all about being able to effectively receive information - whether it comes from customers, colleagues or stakeholders.\n\nInitially, the skill steps concentrate on being able to listen effectively to others - including remembering short instructions, understanding why others are communicating and recording important information.\n\nIndividuals then focus on how they demonstrate that they are listening effectively, thinking about body language, open questioning and summarising and rephrasing.\n\nBeyond that, the focus is on being aware of how they might be being influenced by a speaker, through tone and language.\n\nThe final steps are about critical listening - comparing perspectives, identifying biases, evaluating ideas and being objective.`,
            totalSteps: 10,
            completedSteps: dataArr[0],
            color: '127, 181, 52',
            steps: [
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            link: "http://skillsbuilder.org/homezone",
                        },
                        {
                            link: "https://www.skillsbuilder.org/benchmark",
                        },
                        {
                            link: "https://launchpad.skillsbuilder.org/lesson/speaking-clearly-to-someone-you-know/",
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
                {
                    headLine: "I listen to others without interrupting",
                    preRequisite: "To achieve Step 0, individuals will have to be able to listen to others, without interrupting.\n\nThis is the first step in building this skill, and provides the foundation for more advanced steps in Listening.",
                    resources: [
                        {
                            image: "",
                            headline: "some headline"
                        },
                        {
                            image: "",
                            headline: "some headline"
                        },
                    ],
                    sections: [
                        {
                            headLine: "What it means to listen?",
                            content: "Listening is about being able to receive information through our ears, and then thinking about it so that we understand what is being said.",
                        },
                        {
                            headLine: "What is speaking? 2",
                            content: "Speaking is how we communicate using speech, and is also called talking. We form words using our mouths and add sound to them using our lungs. \n\nThere are other forms of communication, including through writing, performance, sign language, song, and electronic methods of communicating. Some of the principles of speaking can make sense for other forms of communicating too.",
                        }
                    ]
                },
            ]
        },

    ]

    const markAsComplete = (skill, completedSkillStep) => {
        console.log("mark as completed before ", dataArr[skill], completedSkillStep, dataArr[skill] < completedSkillStep)
        if (dataArr[skill] < completedSkillStep && dataArr[skill] + 1 === completedSkillStep) {
            let tempDataArr = [...dataArr]
            console.log("mark as completed triggered")
            tempDataArr[skill] = completedSkillStep
            setCookie("data", tempDataArr)
            props.changeData()
        }
    }

    return (
        <>
            <div className='tab-component'
            >
                <div className='header'>
                    {/* <div className='logo w-20 h-auto'><img src={mySphereLogo} /></div> */}
                    <div className='all-skills'>
                        {skillsData.length > 0 && skillsData.map((skill, i) => {
                            let skillIconPath = `../../assets/mock_skill_img.png`
                            return (
                                <div key={i} onClick={() => { setSelectedSkill(i); setSelectedColor(skill.color); setSelectedSkillStep(0); props.setSelectedColor(skill.color) }} className='skill-wrapper'
                                    style={{
                                        border: `2px solid rgb(${skill.color})`
                                    }}
                                >
                                    <div className='skill-logo'><img src={mockSkillIcon} /></div>
                                    <div className='skill-name'
                                        style={{
                                            backgroundColor: `rgb(${skill.color})`,
                                        }}
                                    ><p className={skill.name.length > 10 ? "marquee-container" : "marquee-container"} style={{ width: skill.name.length > 10 ? "fit-content" : "", textAlign: skill.name.length > 10 ? "" : "center" }}>{skill.name}</p></div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className='overview'
                    style={{
                        backgroundColor: `rgb(${selectedColor})`,
                    }}
                >
                    <div className='overview-left'>
                        <div className='overview-header'
                            style={{
                                color: "white",
                                fontWeight: "bolder",
                            }}
                        ><p className={skillsData[selectedSkill].name.length > 10 ? "" : ""} style={{ width: skillsData[selectedSkill].name.length > 10 ? "fit-content" : "", textAlign: skillsData[selectedSkill].name.length > 10 ? "" : "left" }}>{skillsData[selectedSkill].name}</p></div>
                    </div>
                    <div className='overview-right'>
                        <div className='overview-description'>{skillsData[selectedSkill].description}</div>
                    </div>
                </div>
                <div className='skill-steps'>
                    {skillsData[selectedSkill].steps.map((skill, i) => {
                        return (
                            <div key={i} className='step-wrapper'
                                style={{
                                    color: dataArr[selectedSkill] > i ? "white" : `rgb(${selectedColor})`,
                                    border: selectedSkillStep === i ? `2px solid rgb(${selectedColor})` : "2px solid white",
                                    boxShadow: `${selectedSkillStep === i ? `rgba(${selectedColor}, 15%)` : "rgb(255, 255, 255 , 0.1)"} 20px -20px 20px inset,
                                            rgb(255, 255, 255 , 0.1) 20px -20px 20px`,
                                    backgroundColor: dataArr[selectedSkill] > i ? `rgb(${selectedColor})` : "white",
                                }}
                                onClick={() => { setSelectedSkillStep(i) }}
                            >{i + 1}</div>
                        )
                    })}
                </div>
                <div className='skill-step-headline'
                    style={{
                        background: `rgba(${selectedColor}, 10%)`,
                    }}
                >
                    <div className='headline'>
                        <span
                            style={{
                                color: `rgb(${selectedColor})`
                            }}
                        >STEP {selectedSkillStep + 1} :</span>
                        <span> {skillsData[selectedSkill].steps[selectedSkillStep].headLine}</span>
                    </div>
                    {/* <div className='skill-step-prerequisite'>
                    <span className='text-sm'
                        style={{
                            color: `rgb(${selectedColor})`
                        }}
                    >PREREQUISITE : </span>
                    <span className='text-sm'
                        style={{
                            whiteSpace: "pre-line",
                            lineHeight: "1.4",
                            display: "block"
                        }}
                    > {skillsData[selectedSkill].steps[selectedSkillStep].preRequisite}</span>
                </div> */}
                </div>
                <div className='skill-step-sections w-full'>
                    <div className='skill-step-sections-header text-xl px-4 py-4'
                        style={{
                            color: `rgb(${selectedColor})`,
                        }}
                    ><ChecklistIcon /> Components</div>
                    {skillsData[selectedSkill].steps[selectedSkillStep].sections.map((section, i) => {
                        let skillSectionImage = `/images/section_images/M${0}_S${selectedSkillStep}_S${i}.gif`
                        return (
                            <div key={i} className='section-wrapper py-8 flex'
                                style={{
                                    borderTop: i !== 0 ? `1px solid rgb(${selectedColor})` : '',
                                    // boxShadow: `rgba(0, 0, 0, 0.07) 0px -6px 15px inset`,
                                }}
                            >
                                <div className='section-left w-1/2 max-w-1/2  px-6'
                                    style={{
                                        borderRight: `2px solid rgb(${selectedColor})`
                                    }}
                                >
                                    <div className='section-header mb-2'
                                        style={{
                                            color: `rgb(${selectedColor})`,
                                        }}
                                    >
                                        {section.headLine}
                                    </div>
                                    <div className='section-description text-sm'>
                                        {section.content}
                                    </div>
                                </div>
                                <div className='section-right w-1/2 max-w-1/2 flex items-center justify-center px-6'>
                                    <img src={mockSkillSection} />
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className='skill-step-resources w-full'>
                    <div className='skill-step-resources-header text-xl px-4 py-4'
                        style={{
                            color: `rgb(${selectedColor})`,
                            fontWeight: "bold",
                            boxShadow: `0 0 15px rgba(0,0,0,.2)`,
                        }}
                    ><BuildIcon /> Build this step</div>
                    <div className='all-step-resources w-full flex items-center justify-start px-5 py-7'
                        style={{
                            background: `rgba(${selectedColor}, 15%)`
                        }}
                    >
                        {skillsData[selectedSkill].steps[selectedSkillStep].resources.map((resource, i) => {
                            let resourceImgURL = resource.link
                            let resourceImage = `/images/resource_images/M${0}_S${0}_R${i}.png`
                            let link = "#"
                            if (+resourceImgURL === 1 || +resourceImgURL === 2 || +resourceImgURL === 3) {
                                console.log("external resource = ", resourceImgURL)
                                resourceImage = `/images/resource_images/M${resourceImgURL}_S${0}_R${i}.png`
                                link = resource.url
                            } else {
                                console.log(resourceImgURL)
                            }
                            return (
                                <div key={i} className='resource-wrapper w-24 h-24 flex items-center justify-center p-3 mr-5'>
                                    <a href={link} target='_blank'>
                                        <div className='resource-image '>
                                            <img src={mockSkillResource} />
                                        </div>
                                    </a>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className='assessment w-full flex items-center justify-start p-6'
                >
                    <button className='assessment-btn px-4 py-2'
                        style={{
                            background: `rgb(${selectedColor})`,
                        }}
                        onClick={() => {
                            markAsComplete(selectedSkill, selectedSkillStep + 1)
                        }}
                    >MARK AS COMPLETE</button>
                </div>
            </div>
        </>
    )
}

export default TabsComponent